<template>
    <button
        v-tooltip="{
            content: tooltipText,
            shown: show,
            triggers: ['hover'],
        }"
        class="button button--badge"
        type="button"
        @click.prevent="copy"
    >
        <slot>web</slot>
    </button>
</template>

<script>
import { copyToClipboard } from '../../helpers/functions';

function getCode(audio) {
    return `<div style="display:block; width: 100%; text-align: right; padding: 3px 0;">
<audio controls style="width: 100%; outline: none;">
<source src="${audio}" type="audio/mpeg">
<span style="color:#000;">Тег audio не поддерживается вашим браузером.</span>
<a href="${audio}">Скачайте пример</a>.
</audio>
<div style="margin-top: 3px; font-size: 12px;color: #6f6f6f;">Озвучено в <a href="https://speechki.org/" target="_blank" rel="nofollow" style="color: #FF6B06; text-decoration: none;">Speechki</a></div>
</div>`;
}

export default {
    name: 'EmbedWidgetCopyButton',
    props: {
        audio: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            tooltipText: 'Виджет для установки на ваш или другие сайты',
            show: false,
            timeout: null,
        };
    },
    beforeUnmount() {
        clearTimeout(this.timeout);
    },
    methods: {
        copy() {
            if (this.timeout) return;
            this.show = true;
            this.tooltipText = 'Код скопирован! Можете установить его на сайте';
            this.timeout = setTimeout(() => {
                copyToClipboard(getCode(this.audio));
                this.show = false;
                this.tooltipText = 'Виджет для установки на ваш или другие сайты';
                this.timeout = null;
            }, 2000);
        },
    },
};
</script>
